// extracted by mini-css-extract-plugin
module.exports = {"container":"_cd39fca5","header":"_ab818f5d","subheader":"_79392c79","icon":"_ffe14a49","link":"_443cb362"};